import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {Router} from '@angular/router';
import {DxPopupComponent} from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import {Moment} from 'moment';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {environment} from '../../../../../../environments/environment';
import {LoginViewModel} from '../../../../../shared/models/general';
import {FusionAuthService} from '../../../../../shared/services/fusion-auth';
import {FileUtils} from '../../../../../shared/utils';
import {RequisitionSignature} from '../../../../shared/models/signature';

export interface SignatureRepresentation {
  username: string;
  signedBy: string;
  signedAt: number | Moment;
  imageChanged: boolean;
  image: string;
}

@Component({
  selector: 'app-signature-dialog',
  templateUrl: './signature-dialog.component.html',
  styleUrls: ['./signature-dialog.component.scss'],
})
export class SignatureDialogComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('popupComponent', {static: true}) public popupComponent?: DxPopupComponent;
  @Input() public popupVisible = false;
  @Output() public closeEvent = new EventEmitter();
  @Input() public signatureToEdit ?: RequisitionSignature;
  @ViewChild('fileInput', {static: true}) public fileInput?: HTMLInputElement;
  public image: string = '';
  public username = '';
  public password = '';
  public selectedFile: File = {} as File;
  public passwordControl: any;
  public user: any;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private fusionAuthService: FusionAuthService,
              public ref: ChangeDetectorRef,
              private router: Router) {
  }

  public close() {
    this.closeEvent.emit();
  }

  public clear() {
    this.image = this.user.data === undefined || this.user.data.signImage === undefined || this.user.data.signImage === null ?
      environment.frontendUrl + 'assets/images/signature.png' : this.user.data.signImage;
    this.username = this.Username;
    this.password = '';
    this.selectedFile = {} as File;
  }

  public get Username() {
    return this.fusionAuthService.Profile !== undefined && this.fusionAuthService.Profile !== null
      ? this.fusionAuthService.Profile.email : 'You Are Not Logged In';
  }

  public ngOnInit(): void {
    this.username = this.Username;
  }

  private waitByUser(callback: Function) {
    this.user = this.fusionAuthService.Profile;
    if (this.user) {
      callback();
    } else {
      setTimeout(() => {
        this.waitByUser(callback);
      }, 1000);
    }
  }

  public loadUserSignature() {
    this.waitByUser(() => {
      this.image = this.user.data === undefined || this.user.data.signImage === undefined || this.user.data.signImage === null ?
        environment.frontendUrl + 'assets/images/signature.png' : this.user.data.signImage;
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.popupVisible && changes.popupVisible.currentValue) {
      if (this.passwordControl !== undefined) {
        setTimeout(() => {
          this.passwordControl.instance().focus();
        }, 500);
      }

      this.ref.detectChanges();
      this.waitByUser(() => {
        this.image = this.user.data === undefined || this.user.data.signImage === undefined || this.user.data.signImage === null ?
          environment.frontendUrl + 'assets/images/signature.png' : this.user.data.signImage;
      });
    }
  }

  public ready(e: any) {
    this.passwordControl = e.component;
  }

  public onFileChanged(event: Event) {
    const element = (event.target as HTMLInputElement);
    const file = element.files && element.files.length > 0 && element.files[0];
    if (!file) {
      return notify('No file found.', 'error');
    }

    if (!file.type.includes('image')) {
      return notify('Only images allowed.', 'error');
    }

    // tslint:disable-next-line:radix
    if (Number.parseInt((file.size / 1024 / 1024).toFixed(4)) > 10) {
      return notify('Only 10 MB files allowed.', 'error');
    }

    this.selectedFile = file;

    FileUtils.convertFileToBase64(this.selectedFile)
      .then(imageString => {
        this.image = imageString;
        this.ref.detectChanges();
      });

    this.popupComponent?.instance.repaint();
  }

  public sign() {
    if (!this.fusionAuthService.IsLoggedIn) {
      notify('Your session expired. You must login to continue.');
      this.router.navigateByUrl('/login').then();
    }
    this.fusionAuthService.login({
      loginId: this.fusionAuthService.Profile.email,
      password: this.password,
      applicationId: ''
    } as LoginViewModel, true, false)
      .pipe(takeUntil(this.onDestroy$)).subscribe(() => {
      if (this.image === environment.frontendUrl + 'assets/images/signature.png') {
        // @ts-ignore
        this.closeEvent.emit({
          image: null,
          imageChanged: false,
          // tslint:disable-next-line:max-line-length
          signedBy: `${this.fusionAuthService.Profile.firstName} ${this.fusionAuthService.Profile.lastName}`,
          username: `${this.fusionAuthService.Profile.firstName} ${this.fusionAuthService.Profile.lastName}`,
          signedAt: Date.now(),
        } as SignatureRepresentation);
      } else {
        this.closeEvent.emit({
          image: this.image,
          imageChanged: true,
          // tslint:disable-next-line:max-line-length
          signedBy: `${this.fusionAuthService.Profile.firstName} ${this.fusionAuthService.Profile.lastName}`,
          username: `${this.fusionAuthService.Profile.firstName} ${this.fusionAuthService.Profile.lastName}`,
          signedAt: Date.now(),
        } as SignatureRepresentation);
      }
      this.clear();
    }, (e) => {
      notify('Invalid password.', 'error');
    });
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
